import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { ConfirmationDialogComponent } from './core/component/confirmation-dialog/confirmation-dialog.component';
import { LoaderComponent } from './core/component/loader/loader.component';
import { PrimengLocaleService } from './shared/service/primeng-locale.service';
import { environment } from '../environment/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast, ConfirmationDialogComponent, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  constructor(private readonly primengLocaleService: PrimengLocaleService) {}

  public ngOnInit() {
    if (environment.gaId) {
      const gtagScript = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${environment.gaId}`;
      document.head.appendChild(gtagScript);

      const inlineScript = document.createElement('script');
      inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${environment.gaId}');
    `;
      document.head.appendChild(inlineScript);
    }
  }
}
